import { useMutation } from '@tanstack/react-query'
import { useApiClient } from 'hooks/useApiClient'
import { type FileRequest } from 'types/fileUpload'

interface usePostImportPointsProps {
  id: number
}

export const usePostImportPoints = ({ id }: usePostImportPointsProps) => {
  const postAPIClient = useApiClient()

  return useMutation({
    mutationFn: async (importPoints: FileRequest) => {
      const body = new FormData()
      body.set('FileUpload', importPoints.File)
      body.set('FileUploadName', importPoints.FileName)
      body.set('FileUploadType', importPoints.FileType)

      const { data, error } = await postAPIClient.post(
        '/admin/rewards-programs/{id}/importpoints',
        {
          params: { path: { id } },
          body: {},
          bodySerializer: () => body,
        }
      )
      return { data, error }
    },
  })
}
